<div class="modal-header">
  <h4 class="modal-title pull-left">{{'Forms.Transportation Subscription' | translate}}</h4>
  <button type="button" class="close btn-close pull-right" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form class="form theme-form needs-validation">
    <div class="row g-3">
      <div class="col-lg-6">
        <div class="form-group">
          <label for="passengerName">{{
            "Forms.Student Name" | translate
            }}</label>
          <input type="text" class="form-control" id="passengerName"
            placeholder="{{'Forms.Student Name' | translate}}"
            [value]="studentName"
            readonly />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label for="passengerId">{{
            "Forms.National Id" | translate
            }}</label>
          <input type="text" class="form-control" id="passengerId"
            placeholder="{{'Forms.National Id' | translate}}"
            [value]="studentNationalId"
            readonly />
        </div>
      </div>
      <div class="col-lg-12">
        <label for="vehicle" class="form-label">{{
          "Forms.Transportation Plan" | translate
          }}</label>
        <select class="form-select" id="vehicle" required>
          <option value="" disabled selected>
            {{ "Forms.Transportation Plan" | translate }}
          </option>
          <option *ngFor="let vehiclePlan of transportationPlans" [value]="vehiclePlan.id">
            {{
            isDirRTL
            ? vehiclePlan.plan_name
            : vehiclePlan.plan_name_latin
            }}
          </option>
        </select>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label for="address">{{
            "Forms.Address" | translate
            }}</label>
          <input type="text" class="form-control" id="address"
            placeholder="{{'Forms.Address' | translate}}" />
          <!-- <app-input-error [control]="vehiclesStopsForm.get('stop_name_latin')"
            [formSubmitted]="formSubmitted"></app-input-error> -->
        </div>
      </div>
      <!-- [value]="selectedStudent ? selectedStudent.student_first_name + ' ' + selectedStudent.student_last_name : ''" -->
      <div class="col-lg-6">
        <div class="form-group">
          <label for="mobile" class="form-label">{{'Forms.Phone' | translate}}</label>
          <div class="input-group">
            <input type="text" class="form-control" id="mobile" required
              placeholder="{{'Forms.Phone' | translate}}" onlyNumbers [MaxDigit]="9">
            <span class="input-group-text">966+</span>
          </div>
          <!-- <app-input-error [control]="vehiclesStopsForm.get('passenger_mobile')" [formSubmitted]="formSubmitted"
            [customMsg]="{ minLength: 'رقم الهاتف 9 أرقام', maxLength: 'رقم الهاتف 9 أرقام' }"></app-input-error> -->
        </div>
      </div>
    </div>
    <div class="footer-actions d-flex jc-c align-items-center mt-3">
      <button class="btn btn-pill btn-primary" type="button" (click)="save()">{{'Forms.Save' | translate}}</button>
      <button class="btn btn-pill btn-outline-primary mx-3" type="button" (click)="closeModal()">{{'Forms.Cancel' |
        translate}}</button>
    </div>
  </form>
</div>